import { WSElement } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IInvoiceTemplate
} from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useMemberClientsQuery } from "../../../query/payments/queries";
import { ButtonDownloadCsv } from "../../../shared/components/ButtonDownloadCsv";
import {
  InvoiceForCSVDataItem,
  mapInvoicesTableToCSV
} from "../../utils/invoicesCSVUtils";
import styles from "./index.module.scss";

type Props = {
  invoices?: IInvoice[];
  invoiceTemplates?: IInvoiceTemplate[];
  isDataReady?: boolean;
};

export const DownloadInvoicesCSV: React.FC<Props> = ({
  isDataReady,
  invoices,
  invoiceTemplates
}) => {
  const queryMemberClients = useMemberClientsQuery();

  if (queryMemberClients.status !== "success" || !isDataReady) {
    return <WSElement className={styles.placeholder} shimmer />;
  }

  return (
    <ButtonDownloadCsv
      getData={async () => {
        const data: InvoiceForCSVDataItem[] = [];

        (invoices || []).forEach(invoice => {
          data.push({
            invoice,
            memberClient: queryMemberClients.data?.find(
              memberClient =>
                invoice?.memberClientId === memberClient.memberClientId
            )!
          });
        });

        (invoiceTemplates || []).forEach(invoiceTemplate => {
          data.push({
            invoiceTemplate,
            memberClient: queryMemberClients.data?.find(
              memberClient =>
                invoiceTemplate.invoiceData?.memberClientId ===
                memberClient.memberClientId
            )!
          });
        });

        return mapInvoicesTableToCSV(data);
      }}
      fileName="Invoices"
    />
  );
};
